import styled from "styled-components";
import { SectionSubtitle, SectionTitle } from "components/Style";
import { PLATFORM_INTRO } from "appLauncher";

const PlatformSection = styled.section`
  padding: 80px 0;
  background-image: url(/assets/about/bar-background-3.png);
  background-position: center;
  background-size: cover;
  position: relative;
  min-height: 509px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const PlatformContainer = styled.div`
  max-width: 1280px;
  margin: 0 auto;
  padding: 0 15px;
  display: flex;
  flex-direction: row;
`;

const PlatformContentContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: stretch;
`;

const PlatformTitleWrapper = styled.div`
  text-align: center;
  margin-bottom: 24px;
`;

const PlatformContent = styled.p`
  font-size: 14px;
  line-height: 1.8;
  color: #666;
  text-align: left;
  margin-bottom: 20px;
  white-space: pre-line;
  max-width: 50%;
`;

const PlatformMiniTitle = styled.div`
  font-size: 18px;
  color: #2640ed;
  font-weight: 600;
  margin-bottom: 16px;
  max-width: 50%;
  text-align: left;
`;

// 已移除图片相关样式

export default function PlatformSectionComponent() {
  return (
    <PlatformSection>
      <PlatformContainer>
        <PlatformContentContainer>
          <PlatformTitleWrapper>
            <SectionTitle>平台介绍</SectionTitle>
            <SectionSubtitle>Platform Introduction</SectionSubtitle>
          </PlatformTitleWrapper>
          <PlatformMiniTitle>投中宝数字保函平台</PlatformMiniTitle>
          <PlatformContent>{PLATFORM_INTRO}</PlatformContent>
        </PlatformContentContainer>
      </PlatformContainer>
    </PlatformSection>
  );
}
